<template>
  <section class="sm-404-sec">
    <div class="sm-wrap sm-404">
      <div class="sm-404__main">
        <a 
          :href="provider.website_url || '/'"
          class="sm-link sm-404__main-logo"
          target="_blank"
        >
          <img-loader 
            v-if="logo"
            :src="logo" 
          />
          <include-svg
            v-else
            :name="'logo-spheremail'"
          />
        </a>

        <h2>This page is lost</h2>
        <p class="sm-lead">The page you are looking for is not available. You may have mistyped the address, or the page may have moved.</p>
        <btn-block
          :text="'Go to homepage'"
          @click="$router.push('/')"
        />
      </div>
      <div class="sm-404__bg-img"></div>
      <p class="sm-404__copy-info">SphereMail, Inc. ©2011-{{new Date().getFullYear()}} All rights reserved</p>
    </div>
  </section>
</template>

<script>
import ImgLoader from '@/components/ImgLoader';
import Btn from '@/components/Buttons';
import imageStore from '@/utils/image-store';
import Urls from '@/settings/urls';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'page-404',
  components: {
    'img-loader': ImgLoader,
    'btn-block': Btn
  },
  created() {
    this.getProvider();
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    }),
    logo() {
      return imageStore(this.provider.image_url);
    }
  },
  methods: {
    ...mapActions({
      getProvider: 'getProvider'
    })
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/_404.scss' as *;
</style>
